import {
  ArrowForwardIos,
  Email,
  Facebook,
  Instagram,
  LineStyle,
  LinkedIn,
  Padding,
  Twitter,
  WhatsApp,
  YouTube,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Divider,
  Button,
  Stack,
  Link,
  TextField,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import AddressServices from "apis/address/AddressServices";
import Images from "assets/images/Images";
import Colors from "assets/style/Colors";
import { ErrorToaster } from "components/toaster/Toaster";
import { useLanguage } from "context/UseContext";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import moment from "moment/moment";
// import { changeLanguage } from "i18next";

function Footer() {
  // const { lang } = useLanguage();
  const [settings, setSettings] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang, changeLanguage, languages } = useLanguage();

  const QuickLinks = [
    { path: "/", name: "home" },
    { path: "/blog", name: "blogs" },
    { path: "/about-us", name: "aboutUs" },
    { path: "/terms-conditions", name: "termsConditions" },
  ];

  
  const getSettings = async () => {
    try {
      const { responseCode, data } = await AddressServices.getSettings();
      if (responseCode === 200) {
        setSettings(data.result);
      }
    } catch (error) {
      ErrorToaster(lang === "ar" ? error?.messageAr : error?.message);
    }
  };
  useEffect(() => {
    getSettings();
  }, []);

  return (
    <Box sx={{ backgroundColor:  Colors.tertiary, color: "white", pt: 6, pb: 3 ,mt:2}}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Left - Logo + Tagline */}
          <Grid
            item
            xs={12}
            md={6}
            sx={
              lang === "ar"
                ? {
                    paddingLeft: "0px !important",
                    marginLeft: "0px !important",
                  }
                : ""
            }
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-start" },
                gap: 1,
              }}
            >
              <Box
                component="img"
                src={Images.logo}
                alt="Logo"
                sx={{ height: 40 }}
              />
            </Box>
          </Grid>

          {/* Right - Email Subscription */}
          <Grid
            item
            xs={12}
            md={6}
            sx={
              lang === "ar"
                ? {
                    paddingLeft: "0px !important",
                    marginLeft: "0px !important",
                  }
                : ""
            }
          >
            <Stack
              direction="row"
              justifyContent={{ xs: "center", md: "flex-end" }}
              spacing={1}
              alignItems="center"
            >
             {/* <TextField
  variant="outlined"
  placeholder={t("EnterMail")}
  size="small"
  value={settings?.email}
  InputProps={{
    classes: {
      notchedOutline: "custom-outline",
    },
  }}
  sx={{
    width: "220px",
  "input":{
  color:Colors.white,
  padding:'7px 20px',
  fontWeight:"normal"
  },
  
  
    "& .MuiOutlinedInput-root": {
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "white",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "white",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "white",
      },
      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: "white",
      },
    },

  }}
/> */}
              <Button
                variant="contained"
                component="a"
                sx={{
                  borderRadius: 1,
                  textTransform: "none",
                  backgroundColor: "white",
                  color: "#3a84a6",
                  fontWeight: 600,
                  fontSize: "12px",
                  padding: {md:"7px 20px",sm:"7px 20px",xs:"10px 40px"},
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                  },
                }}
                href={`mailto:${settings?.email}`}
              >
                {t("contactNow")}
              </Button>
            </Stack>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            justifyContent={"center"}
            sx={
              lang === "ar"
                ? {
                    paddingLeft: "0px !important",
                    marginLeft: "0px !important",
                  }
                : ""
            }
          >
            <Stack
              direction="row"
              spacing={3}
              justifyContent="center"
              alignItems="center"
              flexWrap="wrap"
              gap="15px"
              sx={{
                marginLeft:{xs:lang =="ar" ?3 :1 ,sm:0 ,md :0}
              }}
            >
              {QuickLinks.map((item) => (
                <Link to={item.path} aria-label={item.name} sx={{textDecoration:"none" ,marginLeft:"0px !important"}}>
                  <Box
                    onClick={() => navigate(item?.path)}
                    component={"li"}
                    sx={{ listStyle: "none", mb: "24px" }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { md: "16px", xs: "16px" },
                        color: Colors.white,
                        fontWeight: "normal",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      {t(item.name)}
                    </Typography>
                  </Box>
                </Link>
              ))}
            </Stack>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.3)" }} />

        {/* Bottom - Language + Social + Copyright */}
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%", marginRight: "-16px" }}
          dir={lang === "ar" ? "ltr" : "ltr"}
        >
          {/* Languages */}
          <Grid item md={4}>
            <Stack direction="row" spacing={1}>
              <Button
                variant="text"
                size="small"
                sx={{
                  //   backgroundColor: "white",
                  //   color: "#3a84a6",
                  backgroundColor:
                     lang === "en" ? "white" : "transparent",
                  color:  lang=== "en" ? "#3a84a6" : "white",
                  fontSize: 12,
                  textTransform: "none",
                  px: 2,
                  py: 0.5,
                  borderRadius: "4px",
                }}
                onClick={() => {
                  setSelectedLanguage("en");
                  changeLanguage("en");
                }}
              >
                English
              </Button>
              <Button
                variant="text"
                size="small"
                sx={{
                  backgroundColor:
                     lang === "ar" ? "white" : "transparent",
                  color:  lang=== "ar" ? "#3a84a6" : "white",
                  fontSize: 12,
                  textTransform: "none",
                  px: 2,
                  py: 0.5,
                  borderRadius: "4px",
                }}
                onClick={() => {
                  setSelectedLanguage("ar");

                  changeLanguage("ar");
                }}
              >
                Arabic
              </Button>
            </Stack>
          </Grid>

          <Grid item md={4} display="flex" justifyContent="center">
            <Stack direction="row" spacing={2}>
              <IconButton
                component="a"
                href={settings?.facebook || "#"}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "white", p: 0.5 }}
              >
                <FacebookIcon fontSize="small" />
              </IconButton>
              <IconButton
                component="a"
                href={settings?.instagram || "#"}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "white", p: 0.5 ,m:"0px !important" }}
              >
                <InstagramIcon fontSize="small" />
              </IconButton>
              <IconButton
                component="a"
                href={settings?.linkedin || "#"}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "white", p: 0.5 ,m:"0px !important" }}

              >
                <LinkedInIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Grid>

          <Grid
            item
            md={4}
            xs={12}
            display={"flex"}
            sx={{
              justifyContent: { md: "flex-end", sm: "flex-end", xs: "center" },
              mt: { md: "0px", sm: "0px", xs: 2 },
            }}
          >
            <Typography
              variant="caption"
              sx={{ opacity: 0.8, fontSize: "12px" }}
            >
              Scriptio 2020 - 2025 © {t("allRightsReserved")}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
